import {withAuthCheck} from '../utils/fetch';
import {httpClient} from '../utils/shared/http-client';

const requestDomain = window.Site.commentsDomain;

const articleReactionsHttpRepositoryContract = Object.seal({
  async getAllReactions() {
    throw Error('Method getAllReactions() not implemented');
  },
  async getUserReactions() {
    throw Error('Method getUserReactions() not implemented');
  },
  async setUserReaction() {
    throw Error('Method setUserReaction() not implemented');
  },
  async deleteUserReaction () {
    throw Error('Method deleteUserReaction() not implemented');
  }
});

const articleReactionsHttpRepository = Object.assign(articleReactionsHttpRepositoryContract, {
  async getAllReactions(articleId) {
    return await httpClient.get(`${requestDomain}articles/${articleId}/reactions`, null, {credentials: 'include'});
  },
  async getUserReactions(articleId) {
    return await httpClient.authorizedGet(
        `${requestDomain}articles/${articleId}/reactions/me`,
        null,
        {credentials: 'include'}
    );
  },
  async setUserReaction (articleId, type) {
    return await withAuthCheck(() =>
      httpClient.post(`${requestDomain}articles/${articleId}/reactions`, null, {type}, false, {credentials: 'include'})
    );
  },
  async deleteUserReaction (articleId) {
    return await withAuthCheck(
      () => httpClient.delete(`${requestDomain}articles/${articleId}/reactions`,
        null,
        {credentials: 'include'}
      ));
  }
});

export {
  articleReactionsHttpRepository
};
